import PropTypes from 'prop-types';

import {
  FooterSimplified,
  SeoSnippetShape,
  AppBanner
} from '@spotahome/ui-library';

import { useSoyuzExperiment } from '@spotahome/soyuz/client';
import { Mediator } from '@spotahome/soyuz-mediator';

import NoSSR from 'react-no-ssr';

import { useSeoCitiesContext } from '../context/SeoCitiesContext';

import { TOGGLE_MAP } from '../common/utils/channels';

import HeaderComponent from './Header';
import FiltersWrapper from './FiltersWrapper';

const SeoPageWrapper = ({
  loadModules,
  modules,
  deviceType,
  seoSnippet = {}
}) => {
  const isDesktop = deviceType === 'desktop';
  const { cityId } = useSeoCitiesContext();
  const isVariant =
    useSoyuzExperiment('IterateSEOLayout').get('behaviour') === 'variant';

  const handlerSwitcherClick = () => {
    Mediator.publish(TOGGLE_MAP);
  };

  return (
    <>
      <AppBanner source="seo" deviceType={deviceType} />
      <HeaderComponent
        deviceType={deviceType}
        onSwitcherClick={handlerSwitcherClick}
      />
      {isVariant ? (
        <NoSSR>
          <FiltersWrapper cityId={cityId} />
        </NoSSR>
      ) : null}
      {modules &&
        loadModules(modules, seoSnippet, {
          isDesktop
        })}
      <FooterSimplified />
    </>
  );
};

SeoPageWrapper.propTypes = {
  modules: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loadModules: PropTypes.func.isRequired,
  deviceType: PropTypes.oneOf(['smartphone', 'tablet', 'desktop']).isRequired,
  seoSnippet: PropTypes.shape(SeoSnippetShape)
};

export default SeoPageWrapper;
